import { render, staticRenderFns } from "./EnabledRolesEditor.vue?vue&type=template&id=5ba129f6&"
import script from "./EnabledRolesEditor.vue?vue&type=script&lang=js&"
export * from "./EnabledRolesEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports